import React from "react";
export const AvaxLogo = () => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 10C0 4.47715 4.47715 0 10 0H20C25.5228 0 30 4.47715 30 10V20C30 25.5228 25.5228 30 20 30H10C4.47715 30 0 25.5228 0 20V10Z"
      fill="#E84142"
    />
    <path
      d="M20.2914 15.3898C20.8111 14.4921 21.6497 14.4921 22.1693 15.3898L25.4056 21.0709C25.9252 21.9685 25.5 22.7008 24.4607 22.7008H17.941C16.9134 22.7008 16.4882 21.9685 16.9961 21.0709L20.2914 15.3898ZM14.0315 4.45277C14.5512 3.55513 15.378 3.55513 15.8977 4.45277L16.6182 5.75198L18.3189 8.74017C18.7323 9.59056 18.7323 10.5945 18.3189 11.4449L12.6142 21.3307C12.0945 22.1339 11.2323 22.6417 10.2756 22.7008H5.53942C4.50005 22.7008 4.07485 21.9803 4.59454 21.0709L14.0315 4.45277Z"
      fill="white"
    />
  </svg>
);

export const BSCLogo = () => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 10C0 4.47715 4.47715 0 10 0H20C25.5228 0 30 4.47715 30 10V20C30 25.5228 25.5228 30 20 30H10C4.47715 30 0 25.5228 0 20V10Z"
      fill="#F3BA2F"
    />
    <path
      d="M11.3588 13.5038L15 9.8625L18.6431 13.5056L20.7619 11.3869L15 5.625L9.24 11.385L11.3588 13.5038ZM5.625 15L7.74375 12.8812L9.8625 15L7.74375 17.1188L5.625 15ZM11.3588 16.4963L15 20.1375L18.6431 16.4944L20.7619 18.6122L15 24.375L9.24 18.615L9.23719 18.6122L11.3588 16.4963ZM20.1375 15L22.2563 12.8812L24.375 15L22.2563 17.1188L20.1375 15ZM17.1488 14.9981H17.1506V15L15 17.1506L12.8522 15.0037L12.8484 15L12.8522 14.9972L13.2281 14.6203L13.4109 14.4375L15 12.8494L17.1497 14.9991L17.1488 14.9981Z"
      fill="white"
    />
  </svg>
);

export const Cronos = () => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 217 250"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    style={{
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: "2",
    }}
  >
    <path
      d="M218.391,25.232c0,-14.753 -11.977,-26.731 -26.73,-26.731l-167.84,0c-14.753,0 -26.731,11.978 -26.731,26.731l0,198.472c0,14.753 11.978,26.731 26.731,26.731l167.84,-0c14.753,-0 26.73,-11.978 26.73,-26.731l0,-198.472Z"
      fill="#000015"
    />
    <path
      d="M107.663,7.517l-98.918,58.407l-0,116.775l98.918,58.368l98.842,-58.368l0,-116.775l-98.842,-58.407Zm69.557,157.879l-69.557,41.065l-69.595,-41.065l0,-82.209l69.595,-41.065l69.557,41.065l0,82.209Z"
      style={{ fill: "#fff", fillRule: "nonzero" }}
    />
    <path
      d="M153.792,151.577l-46.167,27.246l-46.205,-27.246l-0,-54.532l46.205,-27.285l46.167,27.285l-19.217,11.353l-26.95,-15.933l-26.95,15.933l0,31.787l26.95,15.933l26.95,-15.933l19.217,11.392Z"
      style={{ fill: "#fff", fillRule: "nonzero" }}
    />
  </svg>
);

export const ETHLogo = () => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 10C0 4.47715 4.47715 0 10 0H20C25.5228 0 30 4.47715 30 10V20C30 25.5228 25.5228 30 20 30H10C4.47715 30 0 25.5228 0 20V10Z"
      fill="#627EEA"
    />
    <path
      d="M15.0294 3.75V12.0656L22.0578 15.2062L15.0294 3.75Z"
      fill="white"
      fillOpacity="0.602"
    />
    <path d="M15.0294 3.75L8 15.2062L15.0294 12.0656V3.75Z" fill="white" />
    <path
      d="M15.0294 20.595V26.2453L22.0625 16.515L15.0294 20.595Z"
      fill="white"
      fillOpacity="0.602"
    />
    <path d="M15.0294 26.2453V20.594L8 16.515L15.0294 26.2453Z" fill="white" />
    <path
      d="M15.0294 19.2872L22.0578 15.2063L15.0294 12.0675V19.2872Z"
      fill="white"
      fillOpacity="0.2"
    />
    <path
      d="M8 15.2063L15.0294 19.2872V12.0675L8 15.2063Z"
      fill="white"
      fillOpacity="0.602"
    />
  </svg>
);

export const FTMLogo = () => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g transform="matrix(0.0797526,5.63841e-05,-5.63839e-05,0.0797524,-0.14305,-0.143092)">
      <path
        d="M159.648,1.797C246.15,2.415 315.878,73.144 315.26,159.646C314.643,246.149 243.913,315.876 157.411,315.259C70.909,314.642 1.182,243.912 1.799,157.41C2.416,70.908 73.146,1.18 159.648,1.797Z"
        fill="#13b5ec"
      />
    </g>
    <g transform="matrix(0.0797526,5.63841e-05,-5.63839e-05,0.0797524,-0.14305,-0.143092)">
      <path
        d="M170.501,128.245L205.912,107.926L205.619,149.068L170.501,128.245ZM205.137,216.658L157.922,243.75L111.098,215.987L111.441,167.988L158.264,195.752L205.479,168.659L205.137,216.658ZM111.874,107.255L146.992,128.078L111.58,148.397L111.874,107.255ZM164.554,137.999L199.672,158.822L164.26,179.141L164.554,137.999ZM152.505,179.057L117.388,158.235L152.799,137.915L152.505,179.057ZM200.105,98.089L158.795,121.305L117.821,97.501L159.138,73.306L200.105,98.089ZM100.217,93.457L99.301,221.781L157.838,255.505L216.849,222.619L217.765,94.296L159.229,60.571L100.217,93.457Z"
        fill="white"
      />
    </g>
  </svg>
);

export const PolygonLogo = () => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 10C0 4.47715 4.47715 0 10 0H20C25.5228 0 30 4.47715 30 10V20C30 25.5228 25.5228 30 20 30H10C4.47715 30 0 25.5228 0 20V10Z"
      fill="#8247E5"
    />
    <path
      d="M20.4896 11.5015C20.1157 11.2878 19.635 11.2878 19.2077 11.5015L16.2166 13.2641L14.1869 14.3858L11.2493 16.1484C10.8754 16.362 10.3947 16.362 9.96736 16.1484L7.67062 14.7596C7.29674 14.546 7.02967 14.1187 7.02967 13.638V10.9674C7.02967 10.5401 7.24332 10.1128 7.67062 9.8457L9.96736 8.51039C10.3412 8.29674 10.822 8.29674 11.2493 8.51039L13.546 9.89911C13.9199 10.1128 14.1869 10.5401 14.1869 11.0208V12.7834L16.2166 11.6083V9.79228C16.2166 9.36499 16.003 8.93769 15.5757 8.67062L11.3027 6.16024C10.9288 5.94659 10.4481 5.94659 10.0208 6.16024L5.64095 8.72404C5.21365 8.93769 5 9.36499 5 9.79228V14.8131C5 15.2404 5.21365 15.6677 5.64095 15.9347L9.96736 18.4451C10.3412 18.6588 10.822 18.6588 11.2493 18.4451L14.1869 16.7359L16.2166 15.5608L19.1543 13.8516C19.5282 13.638 20.0089 13.638 20.4362 13.8516L22.7329 15.1869C23.1068 15.4006 23.3739 15.8279 23.3739 16.3086V18.9792C23.3739 19.4065 23.1602 19.8338 22.7329 20.1009L20.4896 21.4362C20.1157 21.6499 19.635 21.6499 19.2077 21.4362L16.911 20.1009C16.5371 19.8872 16.27 19.4599 16.27 18.9792V17.27L14.2404 18.4451V20.2077C14.2404 20.635 14.454 21.0623 14.8813 21.3294L19.2077 23.8398C19.5816 24.0534 20.0623 24.0534 20.4896 23.8398L24.816 21.3294C25.1899 21.1157 25.457 20.6884 25.457 20.2077V15.1335C25.457 14.7062 25.2433 14.2789 24.816 14.0119L20.4896 11.5015Z"
      fill="white"
    />
  </svg>
);

export const Invalid = () => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g transform="matrix(0.707627,0.706586,-0.706586,0.707627,12.4656,-5.16444)">
      <path
        d="M12.473,0.041C19.327,0.041 24.89,5.615 24.89,12.481C24.89,19.347 19.327,24.921 12.473,24.921C5.62,24.921 0.056,19.347 0.056,12.481C0.056,5.615 5.62,0.041 12.473,0.041ZM2.72,13.93L11.016,13.937L11.016,22.25C6.737,21.614 3.351,18.219 2.72,13.93ZM22.224,13.946C21.587,18.227 18.204,21.615 13.931,22.25L13.931,13.94L22.224,13.946ZM13.931,2.711C18.21,3.347 21.596,6.743 22.226,11.031L13.931,11.024L13.931,2.711ZM11.016,2.711L11.016,11.022L2.723,11.015C3.359,6.734 6.742,3.347 11.016,2.711Z"
        fill="rgb(244,41,0)"
      />
    </g>
  </svg>
);
